[data-animate] {
  opacity: 0;

  &.animated,
  &.animated-end {
    opacity: 1;
  }
}
